'use client'
import type { ColumnDefWithSkeleton } from '@morpho-org/ui-v6/types'

import { CellTokenAmountPrice } from '@morpho-org/ui-v6/client'
import { CellAllocation, CellSimpleText, Skeleton } from '@morpho-org/ui-v6/server'
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui'

import type { VaultDistributionTableFeatures } from '@/components/VaultPage/vaultDistribution/components/VaultDistributionTable'
import type { VaultDistributionTableRow } from '@/components/VaultPage/vaultDistribution/config'

import { UserCellDashboard } from '@/components/common/Cells/UserCell'

export const columnsDefs: ColumnDefWithSkeleton<
  VaultDistributionTableFeatures,
  VaultDistributionTableRow
>[] = [
  {
    id: 'userAddress',
    accessorFn: row => row.user.address,
    header: () => (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-3xs text-secondary-foreground" style={{ marginLeft: '7px' }}>
            User
          </span>
        </TooltipTrigger>
        <TooltipContent>Address of user holding the position.</TooltipContent>
      </Tooltip>
    ),
    cell: ({ row }) => <UserCellDashboard address={row.original.user.address} />,
    enableSorting: false,
    skeletonCell: <Skeleton className="h-[22px] w-[144px] rounded-[20px]" />
  },
  {
    id: 'amountValue',
    accessorFn: row => row.amountUsd,
    header: () => (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-3xs text-secondary-foreground">Deposit</span>
        </TooltipTrigger>
        <TooltipContent>Amount of loan tokens supplied to the vault.</TooltipContent>
      </Tooltip>
    ),
    cell: ({ row }) => (
      <CellTokenAmountPrice
        token={row.original.token}
        amount={row.original.assets}
        value={row.original.amountUsd}
        withAvatar
      />
    ),
    enableSorting: false,
    skeletonCell: <Skeleton className="h-[22px] w-[195px] rounded-[20px]" />
  },
  {
    id: 'sharePercentage',
    accessorFn: row => row.sharePercentage.value,
    header: () => (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-3xs text-secondary-foreground">% of Deposits</span>
        </TooltipTrigger>
        <TooltipContent>
          Total portion that this position represents within the vault.
        </TooltipContent>
      </Tooltip>
    ),
    cell: ({ row }) => {
      const { value, percentageOffset } = row.original.sharePercentage
      if (value === null) return <CellSimpleText>-</CellSimpleText>
      return (
        <CellAllocation allocation={value} percentageOffset={percentageOffset} index={row.index} />
      )
    },
    skeletonCell: <Skeleton className="h-[22px] w-[68px] rounded-[20px]" />,
    enableSorting: false
  }
]
